import React, { useState, useEffect } from "react";
import { Table, Button, Popconfirm, message, Space, Card } from "antd";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

const RedirectIndex = () => {
  const [redirects, setRedirects] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRedirects();
  }, []);

  const fetchRedirects = async () => {
    setLoading(true);
    try {
      const response = await api.get("/panel/redirect");
      setRedirects(response.data.data);
    } catch (error) {
      message.error("خطا در دریافت لیست ری‌دایرکت‌ها");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/panel/redirect/${id}`);
      message.success("ری‌دایرکت با موفقیت حذف شد");
      fetchRedirects();
    } catch (error) {
      message.error("خطا در حذف ری‌دایرکت");
    }
  };

  const columns = [
    {
      title: "آی‌دی",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "آدرس مبدأ",
      dataIndex: "source_url",
      key: "source_url",
    },
    {
      title: "آدرس مقصد",
      dataIndex: "destination_url",
      key: "destination_url",
    },
    {
      title: "نوع ری‌دایرکت",
      dataIndex: "redirect_type",
      key: "redirect_type",
    },
    {
      title: "وضعیت",
      dataIndex: "is_active",
      key: "is_active",
      render: (is_active) => (is_active ? "فعال" : "غیرفعال"),
    },
    {
      title: "عملیات",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => navigate(`/redirects/edit/${record.id}`)}
          >
            
          </Button>
          <Popconfirm
            title="آیا از حذف این ری‌دایرکت مطمئن هستید؟"
            onConfirm={() => handleDelete(record.id)}
            okText="بله"
            cancelText="خیر"
          >
            <Button type="primary" danger icon={<DeleteOutlined />}>
              
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Card>
      <Button
        type="primary"
        onClick={() => navigate("/redirects/add")}
        style={{ marginBottom: 16 }}
      >
        افزودن ری‌دایرکت جدید
      </Button>
      <Table
        dataSource={redirects}
        columns={columns}
        loading={loading}
        rowKey="id"
      />
    </Card>
  );
};

export default RedirectIndex;
